import type { FillContents } from '../../state/actions';

/** A pattern / custom color are fill-dialog only, not part of `FillContents`. */
export type FillChoice = FillContents | 'pattern' | 'color';

export const SOLID_CONTENTS: { value: FillContents; label: string }[] = [
  { value: 'foreground', label: 'Foreground Color' },
  { value: 'background', label: 'Background Color' },
  { value: 'black', label: 'Black' },
  { value: 'white', label: 'White' },
  { value: 'gray', label: '50% Gray' },
  { value: 'transparent', label: 'Transparent' },
];

/** Photoshop-style Contents list for Edit → Fill. */
export const FILL_CONTENTS: { value: FillChoice; label: string }[] = [
  { value: 'foreground', label: 'Foreground Color' },
  { value: 'background', label: 'Background Color' },
  { value: 'color', label: 'Color…' },
  { value: 'pattern', label: 'Pattern' },
  { value: 'black', label: 'Black' },
  { value: 'gray', label: '50% Gray' },
  { value: 'white', label: 'White' },
  { value: 'transparent', label: 'Transparent' },
];
